import { Button, Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function WalkInLog() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const hotel_ids = selectedHotels;

    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        sorting: "1",
        sort_by: "",
    });

    const {
        status: walkInLogStatus,
        data: walkInLogRes,
        refetch: getWalkInLog,
    } = useQuery(
        "/walkIn-log",
        async () => {
            return await HTTP("/dashboard/getWalkingLogs", { ...formData });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getWalkInLog();
    }, []);

    useEffect(() => {
        getWalkInLog();
    }, [formData]);

    useEffect(() => {
        if (walkInLogStatus === "success") {
            const { data: tableData, total } = walkInLogRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [walkInLogStatus, walkInLogRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    const column = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
        },
        {
            title: "Agent",
            dataIndex: "agent_name",
            key: "agent_name",
            sorter: () => {},
        },
        {
            title: "Action",
            dataIndex: "agent_action",
            key: "agent_action",
            sorter: () => {},
        },
        {
            title: "Guest Name",
            dataIndex: "guest_name",
            key: "guest_name",
            sorter: () => {},
        },
        {
            title: "Room No.",
            dataIndex: "room_no",
            key: "room_no",
            sorter: () => {},
        },
        {
            title: "Guest Purpose",
            dataIndex: "guest_purpose",
            key: "guest_purpose",
            sorter: () => {},
        },
        {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
            sorter: () => {},
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            sorter: () => {},
        },
    ];

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        let [start_date, end_date] = selectedDates;
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        setFormData({
            ...formData,
            page: 0,
            start_date,
            end_date,
        });
    }, [selectedDates]);

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getWalkingLogsReport", {
            ...tempFormData,
        });
        downloadCSV(res, `walkin_reports`);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        (getUserRole() == "Super Admin" ||
                            getUserRole() == "Admin" ||
                            getUserRole() == "Management") && (
                            <Button
                                type="primary"
                                className="margin-right-5"
                                onClick={downalodReport}
                            >
                                Download
                            </Button>
                        )
                    }
                />
                <Card className="box-shadow margin-10">
                    {walkInLogStatus !== "loading" &&
                    walkInLogStatus !== "idle" ? (
                        <CustomTable
                            columns={column}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            className="walkinLogsTable"
                            rowKey="id"
                        />
                    ) : (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    )}
                </Card>
            </Card>
        </>
    );
}

export { WalkInLog };
